var _defs, _path, _g, _path2, _text, _g2, _path3, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRi2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 447.417,
    height: 111.109,
    viewBox: "0 0 447.417 111.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1350",
    "data-name": "Rectangle 1350",
    width: 36.266,
    height: 36.266,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1349",
    "data-name": "Rectangle 1349",
    width: 83.486,
    height: 83.486,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1324",
    "data-name": "Group 1324",
    transform: "translate(-912.069 -2748.391)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M565.851,109.282h258.6A55.554,55.554,0,0,1,880,164.836v0a55.554,55.554,0,0,1-55.554,55.554h-258.6a22.628,22.628,0,0,1-17.323-8.069l-32.315-38.445a14.047,14.047,0,0,1,0-18.081l32.315-38.445a22.628,22.628,0,0,1,17.323-8.069",
    transform: "translate(420.569 2639.109)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903",
    transform: "translate(912.069 2786.694)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M500.031,150.461a18.133,18.133,0,1,0,18.133-18.133,18.134,18.134,0,0,0-18.133,18.133",
    transform: "translate(-500.031 -132.328)",
    fill: "#ff8206"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M506.093,146.448a8.058,8.058,0,1,0,8.059-8.058,8.058,8.058,0,0,0-8.059,8.058",
    transform: "translate(416.051 2658.379)",
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Ensures_Quality_compliance",
    "data-name": "Ensures Quality  compliance",
    transform: "translate(995 2800)",
    fontSize: 20,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ensures Quality "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "compliance"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1323",
    "data-name": "Group 1323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900",
    transform: "translate(1276 2761)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M718.706,158.847A41.743,41.743,0,1,0,760.448,117.1a41.741,41.741,0,0,0-41.742,41.742",
    transform: "translate(-718.706 -117.103)",
    fill: "#ff8206"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M727.65,152.926a26.877,26.877,0,1,0,26.877-26.877,26.877,26.877,0,0,0-26.877,26.877",
    transform: "translate(562.35 2649.951)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1311",
    "data-name": "Group 1311",
    transform: "translate(1299.475 2785.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M31.409,22.6a8.809,8.809,0,1,0,8.809,8.809A8.822,8.822,0,0,0,31.409,22.6Zm5.047,7.362-2.025,2.154a.365.365,0,0,0-.1.257l.354,2.958a.332.332,0,0,1-.45.354l-2.7-1.254a.446.446,0,0,0-.289,0l-2.7,1.254a.332.332,0,0,1-.45-.354l.354-2.958a.365.365,0,0,0-.1-.257l-2.025-2.154a.338.338,0,0,1,.193-.547l2.926-.579c.1-.032.193-.064.225-.161l1.447-2.6a.332.332,0,0,1,.579,0l1.447,2.6a.242.242,0,0,0,.225.161l2.926.579A.338.338,0,0,1,36.456,29.962Z",
    transform: "translate(-13.621 -13.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M32.93,18.109a.447.447,0,0,0,0-.611l-1.8-2.122a.558.558,0,0,1-.1-.45L31.9,12.29a.5.5,0,0,0-.225-.579L29.2,10.458a.418.418,0,0,1-.257-.386l-.225-2.8a.426.426,0,0,0-.418-.418l-2.8-.225a.418.418,0,0,1-.386-.257L23.864,3.9a.436.436,0,0,0-.579-.225l-2.6.868a.4.4,0,0,1-.45-.1l-2.122-1.8a.447.447,0,0,0-.611,0l-2.122,1.8a.558.558,0,0,1-.45.1L12.29,3.674a.5.5,0,0,0-.579.225L10.458,6.375a.418.418,0,0,1-.386.257l-2.8.225a.426.426,0,0,0-.418.418l-.225,2.8a.418.418,0,0,1-.257.386L3.9,11.712a.436.436,0,0,0-.225.579l.868,2.636a.4.4,0,0,1-.1.45l-1.8,2.09a.447.447,0,0,0,0,.611l1.8,2.09a.558.558,0,0,1,.1.45l-.9,2.7a.5.5,0,0,0,.225.579L6.343,25.15a.418.418,0,0,1,.257.386L6.825,28.3a.512.512,0,0,0,.45.45l2.765.225a.418.418,0,0,1,.386.257l1.254,2.475a.436.436,0,0,0,.579.225l2.636-.868a.4.4,0,0,1,.45.1l2.09,1.8a.447.447,0,0,0,.611,0l2.09-1.8a.558.558,0,0,1,.45-.1l2.636.868a.5.5,0,0,0,.579-.225l1.254-2.475a.418.418,0,0,1,.386-.257l2.765-.225a.512.512,0,0,0,.45-.45l.225-2.765a.418.418,0,0,1,.257-.386L31.612,23.9a.436.436,0,0,0,.225-.579l-.8-2.636a.4.4,0,0,1,.1-.45ZM17.788,28.076A10.288,10.288,0,1,1,28.076,17.788,10.3,10.3,0,0,1,17.788,28.076Z",
    transform: "translate(0 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRi2);
export default __webpack_public_path__ + "static/media/ri2.45e534e6e65368eceb5e2878fec9b7a4.svg";
export { ForwardRef as ReactComponent };